import status from "./status";
import * as ActionTypes from "../../actions";

//Updates the status apiCalls data for different api call.
var investmentPlanPreferenceApiCalls = {
  fetchInvestmentPlanPreferenceByGoalIdAndUserId: status({
    mapActionToKey: function mapActionToKey(action) {
      return [action.goalId || "null", action.userId].join("-");
    },
    types: [ActionTypes.GET_INVESTMENTPREFERENCEBYUSERIDANDGOALID_REQUEST, ActionTypes.GET_INVESTMENTPREFERENCEBYUSERIDANDGOALID_SUCCESS, ActionTypes.GET_INVESTMENTPREFERENCEBYUSERIDANDGOALID_FAILURE, ActionTypes.RESET_GET_INVESTMENTPREFERENCEBYUSERIDANDGOALID]
  })
};
export default investmentPlanPreferenceApiCalls;